import { createSlice } from "@reduxjs/toolkit";
import { InitialProductFormData } from "../../ConstantData/InitialData";
import { InitialProductDuplicateFormData } from "../../ConstantData/InitialDuplicateData";
const productSlice = createSlice({
  name: "product",
  initialState: {
    productList: [],
    dataEdit: {},
    errorData: {},
    isError: false,
    initialData: InitialProductFormData,
    initialDuplicateData: InitialProductDuplicateFormData,
  },
  reducers: {
    getAllProduct: (state, action) => {
      state.productList = action.payload;
    },
    getProductDataEdit: (state, action) => {
      state.dataEdit = action.payload;
    },
    setErrorData: (state, action) => {
      state.errorData = action.payload.message;
      state.isError = action.payload.isError;
    },
    setInitialData: (state) => {
      state.initialData = { ...InitialProductFormData };
    },
    setDuplicateInitialData: (state) => {
      state.initialDuplicateData = { ...InitialProductDuplicateFormData };
    },
    updateProduct: (state, action) => {},
    deleteProduct: () => {},
  },
});

export const productSliceAction = productSlice.actions;
export default productSlice.reducer;
